import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

function Navbar({ onOpenQuote, onOpenStory }) {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if (mobileOpen) document.body.classList.add('menu-open');
        else document.body.classList.remove('menu-open');
    }, [mobileOpen]);

    const navLinks = [
        { name: "Home",      href: "#home" },
        { name: "Services",  href: "#services" },
        { name: "Portfolio", href: "#portfolio" },
        { name: "Process",   href: "#process" },
        { name: "Contact",   href: "#contact" },
    ];

    const handleStoryClick = (e) => {
        e.preventDefault();   // prevent default anchor jump
        onOpenStory();        // let App.js handle show + scroll
    };

    return (
        <header className={`fixed w-full z-[60] transition-all duration-300 ${scrolled || mobileOpen ? 'bg-white shadow-sm py-3' : 'bg-transparent py-4 md:py-5'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6 flex justify-between items-center relative z-[60]">

                {/* Logo */}
                <a href="#home" className="flex items-center gap-2 md:gap-3 group z-[60]">
                    <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-gradient-to-tr from-blue-600 to-indigo-600 flex items-center justify-center text-white font-bold shadow-lg shadow-blue-500/30">
                        E
                    </div>
                    <div>
                        <h1 className="font-bold text-lg md:text-xl tracking-tight text-slate-900 leading-none">EZEMS</h1>
                        <p className="text-[9px] md:text-[10px] text-slate-500 font-bold tracking-widest uppercase">Tech Developers</p>
                    </div>
                </a>

                {/* Desktop Nav */}
                <nav className="hidden md:flex gap-6 lg:gap-8 items-center">
                    {navLinks.map(link => (
                        <a
                            key={link.name}
                            href={link.href}
                            className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
                        >
                            {link.name}
                        </a>
                    ))}
                    {/* Our Story — preventDefault stops full reload; onOpenStory handles the rest */}
                    <a
                        href="#our-story"
                        onClick={handleStoryClick}
                        className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
                    >
                        Our Story
                    </a>
                    <button
                        onClick={onOpenQuote}
                        className="px-5 py-2.5 rounded-lg bg-slate-900 text-white text-sm font-bold hover:bg-blue-700 transition-all shadow-lg hover:shadow-blue-500/25"
                    >
                        Get Started
                    </button>
                </nav>

                {/* Mobile Toggle */}
                <button
                    onClick={() => setMobileOpen(!mobileOpen)}
                    className="md:hidden p-2 text-slate-900 focus:outline-none z-[60]"
                >
                    {mobileOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Menu */}
            {mobileOpen && (
                <div className="fixed inset-0 top-0 bg-white z-[50] flex flex-col pt-24 px-6 pb-8 gap-6 md:hidden animate-fade-in overflow-y-auto">
                    <div className="flex flex-col gap-2">
                        {navLinks.map(link => (
                            <a
                                key={link.name}
                                href={link.href}
                                onClick={() => setMobileOpen(false)}
                                className="text-2xl font-bold text-slate-800 py-3 border-b border-slate-50 hover:text-blue-600"
                            >
                                {link.name}
                            </a>
                        ))}
                        <a
                            href="#our-story"
                            onClick={(e) => {
                                e.preventDefault();
                                setMobileOpen(false);
                                onOpenStory();
                            }}
                            className="text-2xl font-bold text-slate-800 py-3 border-b border-slate-50 hover:text-blue-600 block"
                        >
                            Our Story
                        </a>
                    </div>
                    <div className="mt-4">
                        <button
                            onClick={() => { onOpenQuote(); setMobileOpen(false); }}
                            className="w-full py-4 bg-blue-600 text-white font-bold rounded-xl text-lg shadow-lg shadow-blue-500/30"
                        >
                            Request Quote
                        </button>
                    </div>
                    <div className="mt-auto pt-6 text-center text-xs text-slate-400">
                        <p>&copy; {new Date().getFullYear()} EZEMS Tech Developers.</p>
                    </div>
                </div>
            )}
        </header>
    );
}

export default Navbar;